import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { UseFormReturn } from "react-hook-form";
import { ReservationFormData } from "@/hooks/useReservationForm";

interface FormFieldsProps {
  form: UseFormReturn<ReservationFormData>;
}

export const FormFields = ({ form }: FormFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label className="text-sm font-medium mb-2">Nom complet *</Label>
          <Input 
            placeholder="Votre nom et prénom"
            {...form.register("name")}
          />
          {form.formState.errors.name && (
            <p className="text-sm text-destructive mt-1">{form.formState.errors.name.message}</p>
          )}
        </div>
        <div>
          <Label className="text-sm font-medium mb-2">Téléphone *</Label>
          <Input 
            placeholder="Votre numéro de téléphone"
            {...form.register("phone")}
          />
          {form.formState.errors.phone && (
            <p className="text-sm text-destructive mt-1">{form.formState.errors.phone.message}</p>
          )}
        </div>
      </div>
      
      <div>
        <Label className="text-sm font-medium mb-2">Email *</Label>
        <Input 
          type="email" 
          placeholder="votre.email@exemple.com"
          {...form.register("email")}
        />
        {form.formState.errors.email && (
          <p className="text-sm text-destructive mt-1">{form.formState.errors.email.message}</p>
        )}
      </div>

      <div>
        <Label className="text-sm font-medium mb-2">Date de l'événement *</Label>
        <Input 
          type="date"
          {...form.register("eventDate")}
        />
        {form.formState.errors.eventDate && (
          <p className="text-sm text-destructive mt-1">{form.formState.errors.eventDate.message}</p>
        )}
      </div>

      <div>
        <Label className="text-sm font-medium mb-2">Message complémentaire</Label>
        <Textarea 
          placeholder="Précisions sur votre événement, questions spéciales..." 
          rows={4}
          {...form.register("message")}
        />
      </div>
    </>
  );
};